import { render, staticRenderFns } from "./ReminderHoursSettings.vue?vue&type=template&id=c35a1822&"
import script from "./ReminderHoursSettings.vue?vue&type=script&lang=ts&"
export * from "./ReminderHoursSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports